export const useSocialSharingModal = ({ sellerName, sellerId }) => {
    const customEventData = {
        detail: {
            source: 'seller',
            resource_type: 'user',
            resource_id: Number(sellerId),
            is_resource_owner: false,
            interpolation_variables: {
                username: sellerName,
            },
        },
    };

    const openModal = () => {
        const event = new CustomEvent('open-share-modal', customEventData);
        window.dispatchEvent(event);
    };

    return {
        openModal,
    };
};
